import qs from 'qs'
import ServiceBase from './ServiceBase'

// Spin wheel endpoints (ttg controller module/spin_wheel).
// save() draws one prize, queues the prize email, and returns the result.

export interface SpinWheelForm {
  module_id: string
  email: string
  firstname: string
  lastname: string
}

export interface SpinWheelResult {
  success: boolean
  result: 'win' | 'loose' | false
  label?: string
  code?: string
  prizetype?: number
  // True for Points / TTG Coins when the email has no account: nothing is credited yet,
  // so no code is returned and the visitor is asked to register or log in.
  needs_account?: boolean
  result_title?: string
  result_description?: string
  error_login?: boolean
  error_email_invalid?: boolean
  error_already_played?: boolean
  error_email_exist?: boolean
  error_busy?: boolean
}

export interface SpinWheelPlacement {
  module_id: number
  labels: string[]
  when_to_display: number
  spin_popup_time: number
  spin_scroll_time: number
  display_interval: number
}

const FORM_HEADERS = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }

class SpinWheelService extends ServiceBase {
  async placement(page: 'home' | 'product' | 'account', productId?: number): Promise<SpinWheelPlacement | null> {
    const response = await this.getApi('module/spin_wheel/placement', {
      page,
      ...(productId ? { product_id: productId } : {})
    })
    return response?.module ?? null
  }

  spin(form: SpinWheelForm): Promise<SpinWheelResult> {
    // postApi prefixes the API base (which already carries the route parameter).
    return this.postApi('module/spin_wheel/save', qs.stringify(form), FORM_HEADERS)
  }
}

export default new SpinWheelService()
